<template>
    <td-dialog :title="$t(title)" :before-close="dlalogClose" :visible.sync="addDevceAvailable" :close-on-click-modal="false" :close-on-press-escape="false" :width="addDialogWidth + 'px'">
        <component
            v-bind:is="currentTabComponent"
            @dlalogClose="dlalogClose"
            :iDeviceTypes="iDeviceTypes"
            :editItem="editItem"
            :isAddData="isAddData"
            :devDisplay="devDisplay"
            :nameDisplay="nameDisplay"
            :ipDisplay="ipDisplay"
            :ipTypeDisplay="ipTypeDisplay"
            :iPSegmentDisplay="iPSegmentDisplay"
            :portDisplay="portDisplay"
            :descriptionDisplay="descriptionDisplay"
            :masterServeDisplay="masterServeDisplay"
            :domainTypeDisplay="domainTypeDisplay"
            :isOrgDevTree="isOrgDevTree"
            :parentDevType="parentDevType"
            :orgId="orgId"
            :addTitle="title"
            :orgInfo="orgInfo"
            :defaultPort="defaultPort"
            :deviceLable="deviceLable"
            :portLable="portLable"
            :extendGroupFlg="extendGroupFlg"
            :spanNum="spanNum"
            :isShowAutoId="isShowAutoId"
            :belongDevRequired="belongDevRequired"
            @submit="submit"
            @belongDevChange="belongDevChange"
            @setSubmitDevType="setSubmitDevType"
            @handleExtendDataMethod="handleExtendDataMethod"
            :beforeSubmitForm="beforeSubmitForm"
            ref="addDevice"
            :fatherAutoCreateId="fatherAutoCreateId"
            :regularCheckID="regularCheckID"
            :isHandleExtendData="isHandleExtendData"
            :isCloseDialog="isCloseDialog"
            :devIdReadOnly="devIdReadOnly"
            :devInfoFormLabelWidth="addDevInfoFormLabelWidth"
            v-bind="$attrs"
            v-on="$listeners"
        >
        </component>
        <span slot="footer"> </span>
    </td-dialog>
</template>
<script>
export default {
    props: {
        /* 添加时，表单域标签的宽度设置 */
        addDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 110;
            }
        },
        /* 添加dialog宽度设置 */
        addDialogWidth: {
            type: [Number, String],
            default: function() {
                return 800;
            }
        },
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        addDevceAvailable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 组织id
        orgId: {
            type: String
        },
        // 所属设备是否显示
        devDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 名称是否显示
        nameDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //ip类型是否显示
        ipTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // IP是否显示
        ipDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 端口是否显示
        portDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 顶级中间件是否显示
        masterServeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 域类型是否显示
        domainTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 描述是否显示
        descriptionDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 所属设备是否为组织设备树
        isOrgDevTree: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        deviceLable: {
            type: String
        },
        portLable: {
            type: String
        },
        defaultPort: {
            type: Number,
            default: function() {
                return 3000;
            }
        },
        // 每行显示列数
        spanNum: {
            type: Number,
            default: function() {
                return 12;
            }
        },
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },

        parentDevType: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isAddData: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        deviceTemplate: {
            type: String,
            default: function() {
                return 'TdDeviceInfo';
            }
        },
        orgInfo: {
            type: Object,
            default: function() {
                return null;
            }
        },
        fatherAutoCreateId: {
            type: Function,
            default: null
        },
        isShowAutoId: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        // IP段是否显示
        iPSegmentDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //所属设备是否必填
        belongDevRequired: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 设备ID是否进行正则校验
        regularCheckID: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备ID是否只读
        devIdReadOnly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理扩展元素数据
        isHandleExtendData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存后，是否触发关闭dialog方法
        isCloseDialog: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //表单提交前触发的方法
        beforeSubmitForm: Function
    },

    data() {
        return {
            paneName: '',
            loading: false
        };
    },
    mounted() {},
    computed: {
        // currentTabComponent: function() {
        //     // 路径不支持动态
        //     if (this.paneName === '') {
        //         return () => import(`@/modules/device/tabs/${this.deviceTemplate}`);
        //     }
        //     return () => import(`@/modules/device/tabs/${this.paneName}`);
        // }
        currentTabComponent: function() {
            // 路径不支持动态
            if (this.paneName === '') {
                return this.deviceTemplate;
            }
            return this.paneName;
        }
    },
    created() {
        if (this.paneName === '') {
            this.editableTabsValue = this.deviceTemplate;
        }
    },

    methods: {
        submitForm(formName) {
            this.loading = true;
            this.$refs.addDevice.submitForm(formName);
        },
        submit() {
            this.$emit('submit');
        },
        //设置提交保存的设备类型
        setSubmitDevType(submitDevType, callback) {
            this.$emit('setSubmitDevType', submitDevType, function(type) {
                callback(type);
            });
        },
        //保存时是否处理扩展元素数据
        handleExtendDataMethod(extendData, callback) {
            this.$emit('handleExtendDataMethod', extendData, function(data) {
                callback(data);
            });
        },
        // 所属设备change事件
        belongDevChange(value) {
            this.$emit('belongDevChange', value);
        },
        // 关闭窗口之前需要调用的方法
        dlalogClose() {
            this.$log.info('dlalogClose');
            this.$emit('dlalogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
